import { ConversationFlowAuditLogEntry } from 'apis/auditLogs';

type RoutedThroughDialInputProps = {
  node: ConversationFlowAuditLogEntry<'EXTERNAL_DATA_PHONE_INPUT_NODE_VISITED'>;
};

export function RoutedThroughDialInput({
  node,
}: RoutedThroughDialInputProps): JSX.Element {
  return (
    <>
      Dial input <strong>{node.variable_name}</strong> ·{' '}
      <strong>{node.input}</strong>
    </>
  );
}
